import { Link } from 'react-router-dom';
import { EmptyState } from '../components/states';

export function NotFoundPage() {
  return (
    <main className="public-page">
      <EmptyState title="Page not found" action={
          <Link className="button button-primary" to="/">
            Go to your agencies
          </Link>
        }>
        That address does not match any screen.
      </EmptyState>
    </main>
  );
}
